import { createShapeNormalizer } from '@change-corgi/fcm/normalizers';

import { defineFcm } from '../shared/factory';

export const FCM_STARTER_SAP_AI_PROMPT = defineFcm('starter_sap_ai_prompt')
	.asJson(
		createShapeNormalizer({
			type: 'object',
			shape: {
				isEnabled: { type: 'boolean' },
				legacyAPI: { type: 'boolean', optional: true },
				systemPrompt: { type: 'string' },
				prompt: {
					type: 'array',
					shape: {
						type: 'object',
						shape: {
							replacer: { type: 'string' },
							filter: { type: 'string' },
							text: { type: 'string' },
						},
					},
				},
				options: {
					type: 'object',
					optional: true,
					shape: {
						model: { type: 'string', optional: true },
						temperature: { type: 'number', optional: true },
						frequency_penalty: { type: 'number', optional: true },
					},
				},
			},
		}),
	)
	.withDefault({
		isEnabled: false,
		systemPrompt: '',
		prompt: [],
		legacyAPI: undefined,
		options: undefined,
	})
	.toConfig({
		owner: 'squad-starfish',
		scope: ['corgi-front-end', 'corgi-middle-end'],
		context: 'Start A Petition Page',
		description:
			'Configuration for SAP AI Prompt step: isEnabled determines whether the AI step is enabled for users. If it is enabled, systemPrompt specifies the output format that ChatGPT should return and prompt is an array that will determine what will be sent to the OpenAI API call. Each object in the array contains a "replacer" which is the petition variable we will replace in the "text" field. The "filter" field corresponds to the name of the value passed from the code in the SAP flow.',
		import: false,
		template: {
			isEnabled: true,
			systemPrompt:
				'You write petitions for Change.org users using their input. A Change.org petition is built with one title (less than 90 characters, starts with a verb) and one description (ends with a call to sign the petition). You will always reply with one petition title, and one petition description (nothing before, nothing after).',
			prompt: [
				{
					filter: 'mainPrompt',
					replacer: 'mainPrompt',
					text: 'Write a petition in the style of Change.org to %{mainPrompt}. Do not start the petition with "we, the undersigned". Support the petition with relevant facts and statistics, but only if they are correct and you have good confidence in them. Cite your sources, but do not try to provide links in your response.',
				},
				{
					filter: 'locationName',
					replacer: 'location',
					text: 'The petition will be relevant for people in %{location}.',
				},
				{
					filter: 'personalStory',
					replacer: 'personalStory',
					text: 'This petition is personal to the creator because %{personalStory}. Start the petition with the personal story.',
				},
			],
		},
	});
